import { render, staticRenderFns } from "./ReportSantamSharedServicesAward.vue?vue&type=template&id=822dc6fa&"
import script from "./ReportSantamSharedServicesAward.vue?vue&type=script&lang=js&"
export * from "./ReportSantamSharedServicesAward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports